// @flow
import React from 'react';

export default class HardRefreshToServer extends React.Component<null> {
  componentDidMount() {
    window.location.reload(true);
  }

  render() {
    return null;
  }
}
